import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  DamageDetectionDto,
  DamageDetectionItemDto,
  DamageDetectionItemReferenceDto,
  DamageDetectionReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import DamageDetectionInline from "./DamageDetectionInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: DamageDetectionDto | DamageDetectionReferenceDto | null | undefined;
  entityId?: string | null;
  item?: DamageDetectionItemDto | DamageDetectionItemReferenceDto;
  itemId?: string | null;
}

export default function DamageDetectionLink({
  entity,
  entityId,
  item,
  itemId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.DamageDetectionRead]}
      to={ROUTE_PATH.DAMAGE_DETECTION_VIEW(entity?.id || entityId || "")}
      content={
        <DamageDetectionInline
          entity={entity}
          entityId={entityId}
          item={item}
          itemId={itemId}
          {...inlineProps}
        />
      }
      {...otherProps}
    />
  );
}
